import { PromptModelVersion } from '~/api/sylvanus/typedefs.autogen';
import { PromptModelTestCase } from '~/features/x-ray/types/deprecated';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { mapTestCase } from './transformers';

interface Request {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
}

type Response = PromptModelVersion;

export const getPromptModelTestCases = async ({
  modelId,
  version,
  highlightMethod,
}: Request): Promise<PromptModelTestCase[]> => {
  const response: Response = await sylvanus.get(
    `/model/${modelId}/version/${version}`,
  );

  return Object.values(response.test_cases ?? {}).map((testCase) =>
    mapTestCase(testCase, highlightMethod),
  );
};
